import React from 'react';
import CyberReveal from '../CyberReveal';
import Section from '../Section';
import { RECOMMENDED, WHO_READY_GREEN_GRADIENT } from '../content';
import styles from './Recommended.module.css';

const ASSET_BASE = `${process.env.PUBLIC_URL}/assets/images/raid2026`;

// PDF フライヤー準拠。各項目に対応する Who's ready アイコンを割り当てる。
const ITEMS = [
  { icon: 'whos_ready_01.svg', label: RECOMMENDED[0] },
  { icon: 'whos_ready_02.svg', label: RECOMMENDED[1] },
  { icon: 'whos_ready_03.svg', label: RECOMMENDED[2] },
];

export default function Recommended() {
  return (
    <Section
      id="recommended"
      containerClassName="mx-auto w-full max-w-3xl md:max-w-5xl"
    >
      <div
        className={styles.panel}
        style={{
          '--raid-green-from': WHO_READY_GREEN_GRADIENT.from,
          '--raid-green-to': WHO_READY_GREEN_GRADIENT.to,
        }}
      >
        <header className={styles.header}>
          <p className={styles.title}>Who&apos;s Ready for the RAID?</p>
          <span className={styles.rule} aria-hidden="true" />
          <h2 className={styles.subtitle}>こんな方におすすめ!!</h2>
        </header>
        <ul className={styles.cards}>
          {ITEMS.map(({ icon, label }, index) => (
            <CyberReveal
              key={label}
              as="li"
              className={styles.card}
              delay={index * 120}
              variant="scan"
            >
              <img
                src={`${ASSET_BASE}/${icon}`}
                alt=""
                aria-hidden="true"
                className={styles.icon}
                loading="lazy"
                decoding="async"
              />
              <span className={styles.label}>{label}</span>
            </CyberReveal>
          ))}
        </ul>
      </div>
    </Section>
  );
}
